/* eslint-disable */
import React from 'react';

export function AdminGroupFormScreen() {
  return <div></div>;
}
